export function convertToBase64({ file, fn }) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = event => {
    const dataUrl = event.target.result;
    fn(dataUrl);
  };
}
